<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="row clearfix breadcrumb-margin-lg">
        <div class="col-md-6 col-sm-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item"><a href="#">Helper Master</a></li>
              <li class="breadcrumb-item active" aria-current="page">Edit Helper Master</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-6 col-sm-12 text-right">
          <router-link
            :to="'/admin/master/helper_master'"
            class="btn btn-outline-danger"
            title="Go to Helper Master"
            ><i class="fa fa-arrow-circle-left mr-2"></i>Back</router-link
          >
        </div>
      </div>
    </div>

    <div class="row clearfix">
      <div class="col-md-6 mx-auto">
        <div class="card">
          <div class="card-header bg-primary custom-title theme-backcolor">
            <h6 class="text-white fs">Edit Helper Master</h6>
          </div>
          <!---->
          <v-app class="fixVapp">
            <div class="body">
              <form>
                <div class="form-group">
                  <label class="text-muted">Select HelperType</label>
                  <v-autocomplete
                    attach
                    :rules="nameRules"
                    class="mt-n8"
                    label=""
                    v-model="selected"
                    :items="helpertypes"
                    item-text="helpertype_title"
                    item-value="helpertype_id"
                    outlined
                    dense
                    :error-messages="errors.helpertype_id"
                  ></v-autocomplete>
                </div>
                <div class="form-group mt-n4">
                  <label class="text-muted">Helper Master Title</label>
                  <v-text-field
                    type="text"
                    name="helper_master_title"
                    v-model="helper_master_title"
                    label=""
                    class="mt-n8"
                    :rules="nameRules"
                    outlined
                    dense
                    autocomplete="off"
                    :error-messages="errors.helper_master_title"
                  />
                </div>
                <div class="mx-auto col-md-3 mt-n3">
                  <button
                    type="button"
                    class="btn btn-primary text-white theme-backcolor"
                    @click="updateHelperMaster"
                  >
                    <i class="fa fa-save mr-2"></i>Update
                  </button>
                </div>
              </form>
            </div>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from '../../../dataservice';
export default {
  components: {},
  data() {
    return {
      errors: '',
      helpertypes: [],
      selected: null,
      helper_master_id: null,
      helper_master_title: '',
      helper_master_isactive: 'Y',
      helpertype_id: null,
      Isactive: null,
      nameRules: [value => !!value || 'Required.'],
    };
  },
  methods: {
    getHelperMaster(id) {
      DataService.getHelperMasterById(id).then(response => {
        const _getData = response.data[0];
        this.helper_master_id = _getData.helper_master_id;
        this.helper_master_title = _getData.helper_master_title;
        this.helper_master_isactive = _getData.helper_master_isactive;
        this.selected = _getData.helpertype_id;
      });
    },
    updateHelperMaster() {
      const data = new FormData();
      data.append('helper_master_id', this.helper_master_id);
      data.append('helper_master_title', this.helper_master_title);
      data.append('helper_master_isactive', this.helper_master_isactive);
      data.append('helpertype_id', this.selected);
      DataService.updateHelperMaster(this.helper_master_id, data)
        .then(response => {
          this.s('Helper Master', 'Record updated successfully!');
          this.$router.push({ path: '/admin/master/helper_master' });
        })
        .catch(error => {
          this.errors = error.response.data.error;
          this.e("Oop's", 'Something went wrong.');
        });
    },
  },
  created() {
    DataService.getActiveHelperType()
      .then(response => {
        this.helpertypes = response.data;
      })
      .catch(e => {
        // console.log(e);
      });
    this.getHelperMaster(this.$route.params.id);
  },
};
</script>
<style scoped>
.fixVapp {
  height: 10px;
}
.custom-title {
  padding: 8px 20px !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.fs {
  font-size: 18px !important;
  font-weight: 600 !important;
}
</style>
